// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1iLIW","left":"InfoRow_left__14jA2"};